import MyRouter from "routers/index";

import * as Sentry from "@sentry/react";
import CookieConsent from "components/CookieConsent/CookieConsent";
import EventToBeeChatbot from "components/EventToBeeChatbot/EventToBeeChatbot";

function App() {
  return (
    <div className="text-base bg-white dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <MyRouter />
      <CookieConsent />
      <EventToBeeChatbot />
    </div>
  );
}

export default Sentry.withProfiler(App);
